import Link from 'next/link';
import Image from 'next/image';
import FeatureGate from './FeatureGate';
import { isFeatureEnabled } from '@/lib/features';

export default function Footer() {
  return (
    <footer id="contatti" className="bg-secondary-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link href="/" className="block mb-3">
              {/* eslint-disable-next-line @next/next/no-img-element -- logo pre-ottimizzato 1x/2x */}
              <img
                src="/images/tds-logo-162.png"
                srcSet="/images/tds-logo-162.png 1x, /images/tds-logo-324.png 2x"
                alt="TDS 3D Printing"
                width={162}
                height={56}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-secondary-200 mb-4 max-w-sm text-sm">
              La stampa 3D ti dà la possibilità di realizzare i tuoi prototipi e le tue piccole produzioni in tempi record e a costi molto contenuti.
            </p>
            <div className="space-y-2">
              <a
                href="tel:+390815036695"
                className="flex items-center gap-3 text-secondary-200 hover:text-primary-400 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                +39 081 503 6695
              </a>
              <a
                href="mailto:info@tds-med.com"
                className="flex items-center gap-3 text-secondary-200 hover:text-primary-400 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                info@tds-med.com
              </a>
              <div className="flex items-start gap-3 text-secondary-200">
                <svg className="w-5 h-5 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>
                  Quinta Traversa, Via Vecchia del Bosco<br />
                  80034 Marigliano (NA)
                </span>
              </div>
            </div>
            <div className="flex gap-4 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61587284202163"
                className="w-10 h-10 bg-secondary-400/30 rounded-lg flex items-center justify-center text-secondary-200 hover:bg-primary-500 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/tds_printing/"
                className="w-10 h-10 bg-secondary-400/30 rounded-lg flex items-center justify-center text-secondary-200 hover:bg-primary-500 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/tds-printing1"
                className="w-10 h-10 bg-secondary-400/30 rounded-lg flex items-center justify-center text-secondary-200 hover:bg-primary-500 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Tecnologie */}
          <div>
            <h3 className="font-semibold text-white mb-3">Tecnologie</h3>
            <ul className="space-y-2">
              <li><Link href="/tecnologie/fdm" className="text-secondary-200 hover:text-primary-400 transition-colors">FDM</Link></li>
              <li><Link href="/tecnologie/sla" className="text-secondary-200 hover:text-primary-400 transition-colors">SLA</Link></li>
              <li><Link href="/tecnologie/sls" className="text-secondary-200 hover:text-primary-400 transition-colors">SLS</Link></li>
              <li><Link href="/tecnologie" className="text-secondary-200 hover:text-primary-400 transition-colors">Confronta tecnologie</Link></li>
            </ul>
          </div>

          {/* Materiali */}
          <div>
            <h3 className="font-semibold text-white mb-3">Materiali</h3>
            <ul className="space-y-2">
              <li><Link href="/materiali/pla" className="text-secondary-200 hover:text-primary-400 transition-colors">PLA</Link></li>
              <li><Link href="/materiali/petg" className="text-secondary-200 hover:text-primary-400 transition-colors">PETG</Link></li>
              <li><Link href="/materiali/abs" className="text-secondary-200 hover:text-primary-400 transition-colors">ABS</Link></li>
              <li><Link href="/materiali/resina-standard" className="text-secondary-200 hover:text-primary-400 transition-colors">Resina Standard</Link></li>
              <li><Link href="/materiali/nylon-pa12" className="text-secondary-200 hover:text-primary-400 transition-colors">Nylon PA12</Link></li>
              <li><Link href="/materiali" className="text-secondary-200 hover:text-primary-400 transition-colors">Tutti i materiali</Link></li>
            </ul>
          </div>

          {/* Risorse */}
          <div>
            <h3 className="font-semibold text-white mb-3">Risorse</h3>
            <ul className="space-y-2">
              <li><Link href="/servizi" className="text-secondary-200 hover:text-primary-400 transition-colors">Servizi</Link></li>
              <li><FeatureGate feature="preventivo"><Link href="/preventivo" className="text-secondary-200 hover:text-primary-400 transition-colors">Preventivo online</Link></FeatureGate></li>
              <li><Link href="/blog" className="text-secondary-200 hover:text-primary-400 transition-colors">Blog</Link></li>
              <li><Link href="#" className="text-secondary-200 hover:text-primary-400 transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-white mb-3">Company</h3>
            <ul className="space-y-2">
              <li><Link href="/contatti" className="text-secondary-200 hover:text-primary-400 transition-colors">Contatti</Link></li>
              <li><Link href="#" className="text-secondary-200 hover:text-primary-400 transition-colors">Chi siamo</Link></li>
              <li><Link href="/termini" className="text-secondary-200 hover:text-primary-400 transition-colors">Termini d&apos;uso</Link></li>
              <li><Link href="/privacy" className="text-secondary-200 hover:text-primary-400 transition-colors">Privacy policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bando */}
      <div className="border-t border-secondary-400/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-center">
            <Image
              src="/images/bando.png"
              alt="Bando"
              width={1200}
              height={200}
              className="w-full max-w-4xl h-auto object-contain"
            />
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-secondary-400/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-secondary-200 text-sm">
            TDS Med S.r.l. &mdash; P.IVA 03153020619 &mdash; &copy; Copyright {new Date().getFullYear()} All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}

